import { createApi } from '@reduxjs/toolkit/query/react';
import type { BrowseItemApiDto } from 'tradera/state/services/types/webapi-browse-generated';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';
import { toLocalizedUrl } from 'tradera/utils/url';

type AjaxItemDto = Pick<
    BrowseItemApiDto,
    | 'imageFormats'
    | 'shortDescription'
    | 'longDescription'
    | 'itemId'
    | 'itemCondition'
    | 'itemType'
    | 'endDate'
    | 'bidCount'
    | 'openingBid'
    | 'fixedPrice'
    | 'quantity'
    | 'shippingOptions'
    | 'paymentOptions'
> & {
    url: string;
    auctionVisits: number;
};

export const ajaxItemApi = createApi({
    reducerPath: 'ajaxItemApi',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (builder) => ({
        getAjaxItem: builder.query<
            AjaxItemDto,
            { itemId: number; languageCode: string }
        >({
            query: ({ itemId, languageCode }) =>
                toLocalizedUrl(`/ajax/item/${itemId}`, languageCode)
        })
    })
});

export const { useGetAjaxItemQuery } = ajaxItemApi;
